import React, { useEffect, useState } from "react";
import { fetchCommunityImpact } from "../services/CommunityImpact";

const Comransform = () => {
  const [impactData, setImpactData] = useState(null);

  useEffect(() => {
    const loadImpact = async () => {
      const result = await fetchCommunityImpact();

      if (result?.status && result?.data?.length > 0) {
        setImpactData(result.data[0]);
      }
    };

    loadImpact();
  }, []);

  return (
     <div className="relative -mx-4 px-4 sm:-mx-6 sm:px-6 md:mx-0 md:px-0">
            <div className="flex snap-x snap-mandatory gap-6 overflow-x-auto pb-8 md:grid md:grid-cols-4 md:gap-8 md:overflow-visible">
  <div
                className="group relative min-w-[260px] sm:min-w-[280px] flex-shrink-0 snap-start overflow-hidden rounded-2xl border-2 border-slate-200 bg-white p-6 shadow-lg transition-all duration-700 hover:border-primary/30 hover:shadow-2xl hover:-translate-y-2"
                style={{ transitionDelay: "0ms" }}
            >
                <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-gradient-to-br from-primary/10 to-primary/5 opacity-60 transition-all duration-500 group-hover:opacity-80 group-hover:scale-110" />
                <div className="relative z-10">
                <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-r from-primary to-primary/80 text-white shadow-lg transition-all duration-300 group-hover:scale-110 group-hover:shadow-xl">
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-heart h-7 w-7"
                    >
                    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                    </svg>
                </div>
                <p className="mb-2 text-4xl font-bold bg-gradient-to-r from-primary to-primary/80 bg-clip-text text-transparent transition-all duration-300 group-hover:scale-105">
                    {impactData?.friendships ?? "0"}
                </p>
                <p className="mb-3 text-lg font-semibold text-slate-800 transition-all duration-300 group-hover:text-primary">
                    Lasting Friendships
                </p>
                <p className="text-sm text-slate-600 leading-relaxed transition-all duration-300 group-hover:text-slate-700">
                    Members who've made close friends through our community
                </p>
                </div>
            </div>
            <div
                className="group relative min-w-[260px] sm:min-w-[280px] flex-shrink-0 snap-start overflow-hidden rounded-2xl border-2 border-slate-200 bg-white p-6 shadow-lg transition-all duration-700 hover:border-primary/30 hover:shadow-2xl hover:-translate-y-2"
                style={{ transitionDelay: "150ms" }}
            >
                <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-gradient-to-br from-primary/10 to-primary/5 opacity-60 transition-all duration-500 group-hover:opacity-80 group-hover:scale-110" />
                <div className="relative z-10">
                <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-r from-primary to-primary/80 text-white shadow-lg transition-all duration-300 group-hover:scale-110 group-hover:shadow-xl">
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-globe h-7 w-7"
                    >
                    <circle cx={12} cy={12} r={10} />
                    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                    <path d="M2 12h20" />
                    </svg>
                </div>
                <p className="mb-2 text-4xl font-bold bg-gradient-to-r from-primary to-primary/80 bg-clip-text text-transparent transition-all duration-300 group-hover:scale-105">
                   {impactData?.together ?? "0"}
                </p>
                <p className="mb-3 text-lg font-semibold text-slate-800 transition-all duration-300 group-hover:text-primary">
                    Travel Together
                </p>
                <p className="text-sm text-slate-600 leading-relaxed transition-all duration-300 group-hover:text-slate-700">
                    Members who've traveled with people they met in the community
                </p>
                </div>
            </div>
            <div
                className="group relative min-w-[260px] sm:min-w-[280px] flex-shrink-0 snap-start overflow-hidden rounded-2xl border-2 border-slate-200 bg-white p-6 shadow-lg transition-all duration-700 hover:border-primary/30 hover:shadow-2xl hover:-translate-y-2"
                style={{ transitionDelay: "300ms" }}
            >
                <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-gradient-to-br from-primary/10 to-primary/5 opacity-60 transition-all duration-500 group-hover:opacity-80 group-hover:scale-110" />
                <div className="relative z-10">
                <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-r from-primary to-primary/80 text-white shadow-lg transition-all duration-300 group-hover:scale-110 group-hover:shadow-xl">
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-award h-7 w-7"
                    >
                    <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
                    <circle cx={12} cy={8} r={6} />
                    </svg>
                </div>
                <p className="mb-2 text-4xl font-bold bg-gradient-to-r from-primary to-primary/80 bg-clip-text text-transparent transition-all duration-300 group-hover:scale-105">
                    {impactData?.connection ?? "0"}
                </p>
                <p className="mb-3 text-lg font-semibold text-slate-800 transition-all duration-300 group-hover:text-primary">
                    Cultural Connection
                </p>
                <p className="text-sm text-slate-600 leading-relaxed transition-all duration-300 group-hover:text-slate-700">
                    Report feeling more connected to local cultures
                </p>
                </div>
            </div>
            <div
                className="group relative min-w-[260px] sm:min-w-[280px] flex-shrink-0 snap-start overflow-hidden rounded-2xl border-2 border-slate-200 bg-white p-6 shadow-lg transition-all duration-700 hover:border-primary/30 hover:shadow-2xl hover:-translate-y-2"
                style={{ transitionDelay: "450ms" }}
            >
                <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-gradient-to-br from-primary/10 to-primary/5 opacity-60 transition-all duration-500 group-hover:opacity-80 group-hover:scale-110" />
                <div className="relative z-10">
                <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-r from-primary to-primary/80 text-white shadow-lg transition-all duration-300 group-hover:scale-110 group-hover:shadow-xl">
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-trending-up h-7 w-7"
                    >
                    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                    <polyline points="16 7 22 7 22 13" />
                    </svg>
                </div>
                <p className="mb-2 text-4xl font-bold bg-gradient-to-r from-primary to-primary/80 bg-clip-text text-transparent transition-all duration-300 group-hover:scale-105">
                    {impactData?.rating ?? "0"}
                </p>
                <p className="mb-3 text-lg font-semibold text-slate-800 transition-all duration-300 group-hover:text-primary">
                    Satisfaction Rating
                </p>
                <p className="text-sm text-slate-600 leading-relaxed transition-all duration-300 group-hover:text-slate-700">
                    Average rating from community members
                </p>
                </div>
            </div>
      </div>
        </div>
  );
};

export default Comransform;
